"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = void 0;
exports.version = '2.21.29';
//# sourceMappingURL=version.js.map